import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import {GlobalConstants} from "../data/GlobalConstants";

const modalSideSubject = new Subject();
const defaultId = 'defaultModalSide';

export const modalSideService = {
    onModalSide,
    modalSide,
    clear,
    showModal,
    defaultId
};


function onModalSide(id = defaultId) {
    return modalSideSubject.asObservable().pipe(filter(x => x && x.id === id));
}

function showModal({type, props, title, isAddMode = false, isAddModeFromNode = false, isEditable= true, dense = true, id = defaultId, size='lg'}) {
    modalSide({ type, title, isAddMode, isAddModeFromNode, isEditable, dense, id, size, props });
}

function modalSide(modalSide) {
    modalSide.id = modalSide.id || defaultId;
    modalSideSubject.next(modalSide);
}

function clear(id = defaultId) {
    modalSideSubject.next({ id });
}
